import React, { useState } from 'react';
import { useLocale } from 'client/i18n/hooks/useLocale';
import { GlobeIcon } from '../svgs/GlobeIcon';
import { LanguageSelectorButton, LanguageSelectorDisplay } from './styles';
import { LanguageSelectionModal } from './LanguageSelectionModal';

export function LanguageSelector({ isDesktop }: { isDesktop?: boolean }) {
  const { locale } = useLocale();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <LanguageSelectorButton
      data-cy="language-selector__button__nav"
      onClick={() => setIsOpen(!isOpen)}
      tabIndex={0}
    >
      <LanguageSelectorDisplay
        className={isOpen ? 'opened' : 'closed'}
        data-cy="language-selector__display__nav"
      >
        <GlobeIcon
          additionalAriaId={`languageSelectorNav${isDesktop ? 'Desktop' : ''}`}
        />
        <span>{locale}</span>
      </LanguageSelectorDisplay>

      {isOpen && <LanguageSelectionModal onClose={() => setIsOpen(false)} />}
    </LanguageSelectorButton>
  );
}
